import React, { useState } from 'react';
import './planSummaryCard.scss';
import dedicatedIcon from '../../../../../../assests/dedicated-icon.png';
// import KnowMore from "../knowMore/knowMore";
import { capitalizeText, numberWithCommas } from 'common/utils/app.utils';
import { getProductDisplayName, isNLD_OR_LL, isBulkUpgrade } from 'common/constants/app.constants';

const PlanSummaryCard = ({ order: { lead, serviceType }, downloadSites = () => {} }) => {
  const { planDetail, lineItemCount } = lead;
  const [showKnowMoreClick, setShowKnowMoreClick] = useState(false);

  const onShowMoreClick = () => {
    setShowKnowMoreClick(!showKnowMoreClick);
  };

  const getServiceName = (serviceType) => {
    return getProductDisplayName(serviceType);
  };

  const getTotalSitesOrLinks = () => {
    if (isNLD_OR_LL()) {
      return Math.floor(lineItemCount / 2);
    }
    return lineItemCount;
  };

  return (
    <React.Fragment>
      <div className="plan_summary_card">
        <div className="plan_items">
          <div className="items-card">
            <div className="topcard-head">
              <img src={dedicatedIcon} className="icon-box" />
              <span className="title">{getServiceName(serviceType)}</span>
            </div>
            <div className="bottom-section">
              <div className="total-sites">
                {isNLD_OR_LL() ? 'Total Links' : 'Total Sites'}
                <span className="inner-value">{lineItemCount ? getTotalSitesOrLinks() : '-'}</span>
              </div>
              <div className="total-contract-value">
                <p>Total Contract Value</p>
                <span className="inner-value"> &#8377; {planDetail ? numberWithCommas(planDetail.totalPrice) : '-'} </span>
              </div>
            </div>

            {isBulkUpgrade() ? (
              <div className="more-link">
                <div className="upload_text">
                  <span onClick={downloadSites} class="link">
                    Download Sites
                  </span>
                </div>
              </div>
            ) : null}

            <div className="installation-details">
              <div className="other-details">
                <div className="installation-info">
                  &#8377; {planDetail && numberWithCommas(planDetail.priceDto.otc)}
                  <span>Total Installation Fee (one-time charge)</span>
                </div>
                <div className="annual-charge">
                  &#8377; {planDetail ? numberWithCommas(planDetail.priceDto.amount) : '-'}
                  <span>Total Annual Charge (per year, ex. GST)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PlanSummaryCard;
